/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import html2canvas from "html2canvas";

// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import moment from 'moment';
import { AxiosGet, AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import { BtnExportExcel, BtnIconSearch, BtnSearch } from 'components/Common/Button';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import TotalVOCBarChart from './components/TotalVOCBarChart';
import PieAndBarSummaryChart from './components/PieAndBarSummaryChart';
import TypeComplaintBarChart from './components/TypeComplaintBarChart';
import TypeVOCBarChart from './components/TypeVOCBarChart';
import TypeRequestBarChart from './components/TypeRequestBarChart';
import TypeSuggestionBarChart from './components/TypeSuggestionBarChart';
import BASummaryChart from './components/BASummaryChart';

const StatisticsVOCReport = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [optionBA, setoptionBA] = useState([] as any);
    const [optionYear, setoptionYear] = useState([] as any);
    const [optionAll, setoptionAll] = useState(null)
    const [sBA, setsBA] = useState("")
    const [ImgChart, setImgChart] = useState([] as any);
    const [nCountAllDiv, setnCountAllDiv] = useState(0)
    const [IsSearch, setIsSearch] = useState(false)

    const [IsExport, setIsExport] = useState(true)
    const [ListBA, setListBA] = useState([] as any)
    const [dataDiv1, setdataDiv1] = useState(null)
    const [dataDiv2, setdataDiv2] = useState(null)
    const [dataDiv3, setdataDiv3] = useState([] as any)
    const [dataDiv4, setdataDiv4] = useState([] as any)
    const [dataDiv5, setdataDiv5] = useState([] as any)
    const [dataDiv6, setdataDiv6] = useState([] as any)
    const [dataBaCMM, setdataBaCMM] = useState(null)
    const [dataBaGSM, setdataBaGSM] = useState(null)
    const [dataBaNGR, setdataBaNGR] = useState(null)
    const [dataBaNGV, setdataBaNGV] = useState(null)

    //#region  Form
    let objSchema = {
        arrYear: yupFormSchemas.stringArray("ปี", { required: true }),
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        onGetOptionAll();
    }, [])

    useEffect(() => {
        let gDiv1 = document.querySelectorAll('[id^="chart-summary-voc"]').length;
        let gDiv2_1 = document.querySelectorAll('[id^="typevoc-pie"]').length;
        let gDiv2_2 = document.querySelectorAll('[id^="chart-year"]').length;
        let gDiv3_1 = document.querySelectorAll('[id^="chart-complaint"]').length;
        let gDiv3_2 = document.querySelectorAll('[id^="chart-request"]').length;
        let gDiv4_1 = document.querySelectorAll('[id^="chart-1-comp"]').length;
        let gDiv4_2 = document.querySelectorAll('[id^="chart-2-comp"]').length;
        let gDiv4_3 = document.querySelectorAll('[id^="chart-3-comp"]').length;
        let gDiv4_4 = document.querySelectorAll('[id^="chart-4-comp"]').length;
        let gDiv5_1 = document.querySelectorAll('[id^="chart-1-req"]').length;
        let gDiv5_2 = document.querySelectorAll('[id^="chart-2-req"]').length;
        let gDiv5_3 = document.querySelectorAll('[id^="chart-3-req"]').length;
        let gDiv5_4 = document.querySelectorAll('[id^="chart-4-req"]').length;
        let gDiv5_5 = document.querySelectorAll('[id^="chart-5-req"]').length;
        let gDiv5_6 = document.querySelectorAll('[id^="chart-6-req"]').length;
        let gDiv6 = document.querySelectorAll('[id^="chart-1-sug"]').length;
        let gDivPiecmm = document.querySelectorAll('[id^="pie-cmm"]').length;
        let gDivBarcmm = document.querySelectorAll('[id^="bar-cmm"]').length;
        let gDivPiegsm = document.querySelectorAll('[id^="pie-gsm"]').length;
        let gDivBargsm = document.querySelectorAll('[id^="bar-gsm"]').length;
        let gDivPiengr = document.querySelectorAll('[id^="pie-ngr"]').length;
        let gDivBarngr = document.querySelectorAll('[id^="bar-ngr"]').length;
        let gDivPiengv = document.querySelectorAll('[id^="pie-ngv"]').length;
        let gDivBarngv = document.querySelectorAll('[id^="bar-ngv"]').length;
        // let gDivPiecmm = 0 // document.querySelectorAll('[id^="pie-cmm"]').length;
        // let gDivBarcmm = 0 // document.querySelectorAll('[id^="bar-cmm"]').length;
        // let gDivPiegsm = 0 // document.querySelectorAll('[id^="pie-gsm"]').length;
        // let gDivBargsm = 0 // document.querySelectorAll('[id^="bar-gsm"]').length;
        // let gDivPiengr = 0 // document.querySelectorAll('[id^="pie-ngr"]').length;
        // let gDivBarngr = 0 // document.querySelectorAll('[id^="bar-ngr"]').length;
        // let gDivPiengv = 0 // document.querySelectorAll('[id^="pie-ngv"]').length;
        // let gDivBarngv = 0 // document.querySelectorAll('[id^="bar-ngv"]').length;
        let nCountAllDiv = gDiv1 + gDiv2_1 + gDiv2_2 + gDiv3_1 + gDiv3_2 + gDiv4_1 + gDiv4_2 + gDiv4_3 + gDiv4_4 + gDiv5_1 + gDiv5_2 + gDiv5_3 + gDiv5_4 + gDiv5_5 + gDiv5_6 + gDiv6 + gDivPiecmm + gDivBarcmm + gDivPiegsm + gDivBargsm + gDivPiengr + gDivBarngr + gDivPiengv + gDivBarngv
        setnCountAllDiv(nCountAllDiv)

    }, [document.querySelectorAll('[id^="chart"]'), document.querySelectorAll('[id^="typevoc-pie"]'), document.querySelectorAll('[id^="pie"]'), document.querySelectorAll('[id^="bar"]'),])

    const onGetOptionAll = async () => {
        BlockUI();
        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": false }, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionBA(arrOption)
                if (arrOption.length > 0) {
                    let arrBA = arrOption.map(item => item.nBAID);
                    let arrValue = arrOption.map(item => item.value);
                    setListBA(arrBA)
                    form.setValue("arrBA", arrValue)
                    if (arrOption.length === 4) {
                        setsBA("GBU")
                    }
                    else {
                        let arrBA = arrOption.map(item => item.label);
                        let aa = arrBA.join(', ');
                        setsBA(aa)
                    }
                }
                else {
                    form.setValue("arrBA", null)
                    setListBA([])
                }
            })
        });

        BlockUI();
        await AxiosGet(`Report/GetOptionYear`, {}, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                let arrOption = res || []
                setoptionYear(arrOption)

                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrYear", arrValue)
                }
                else
                {
                    form.setValue("arrYear", null)
                }
            })
        });

        

        await onSearchData(false);
    }

    const onGetOptionStaticVOC = async (obj) => {
        await AxiosPost(`Report/OptionStaticVOC`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                setoptionAll(res)
            })
        });
    }

    const GetDataTotalDiv1 = (obj) => {
        BlockUI();
        AxiosPost(`Report/GetDataTotalDiv1`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                setdataDiv1(
                    {
                        nTotal: res.nTotal,
                        nComplete: res.nComplete,
                        nInvestigate: res.nInvestigate,
                        option: res.option,
                        lstLabel: res.lstLabel,
                        lstdata: res.lstdata,
                    }
                )
            })
        });
    }

    const onLoadGraphTotolDiv1 =(param)=>{
        let obj = {
            "lstYear": form.getValues("arrYear") ?? null,
            "lstBA": form.getValues("arrBA") ?? null,
            ...param
        }
        BlockUI();
        AxiosPost(`Report/GetDataTotalDiv1`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                setdataDiv1(
                    {
                        nTotal: res.nTotal,
                        nComplete: res.nComplete,
                        nInvestigate: res.nInvestigate,
                        option: res.option,
                        lstLabel: res.lstLabel,
                        lstdata: res.lstdata,
                    }
                )
            })
        });
    }

    const GetDataDiv2 = (obj) => {

        BlockUI();
        AxiosPost(`Report/GetDataDiv2`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {

                let lstXY = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYear = [] as any;
                let Result = res.lstdataXY || [];
                if (Result.length > 0) {
                    Result.forEach(itmYear => {

                        lstYear.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstXY[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }

                setdataDiv2(
                    {
                        lstYear: lstYear,
                        lstdataPie: res.lstdataPie,
                        lstdataXY: lstXY
                    }
                )



            })
        });
    }
    
    const GetDataTypeVOCDiv3 = (obj) => {

        BlockUI();
        AxiosPost(`Report/GetDataTypeVOCDiv3`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {

                // Complaint
                let lstdataComplaints = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearComp = [] as any;
                let ResComplaint = res.lstdataComplaint || [];
                if (ResComplaint.length > 0) {
                    ResComplaint.forEach(itmYear => {

                        lstYearComp.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataComplaints[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }

                //Request
                let lstdataRequests = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearReq = [] as any;
                let ResRequest = res.lstdataRequest || [];
                if (ResRequest.length > 0) {
                    ResRequest.forEach(itmYear => {
                        lstYearReq.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataRequests[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }

                let dataDiv3 = [
                    {
                        sID: "1",
                        sTitle: "ข้อร้องเรียน",
                        chartname: "chart-complaint",
                        lstdata: lstdataComplaints,
                        lstYear: lstYearComp,
                    },
                    {
                        sID: "2",
                        sTitle: "ข้อร้องขอ",
                        chartname: "chart-request",
                        lstdata: lstdataRequests,
                        lstYear: lstYearReq
                    }
                ]

                setdataDiv3(dataDiv3)



            })
        });
    }

    const GetDataTypeComplaintDiv4 = (obj) => {
        BlockUI();
        AxiosPost(`Report/GetDataTypeComplaintDiv4`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {

                //#region ข้อร้องเรียนปกติ   Commercial
                let lstdataNorCom = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearComp = [] as any;
                let ResNorComm = res.lstdataNorComm || [];
                if (ResNorComm.length > 0) {
                    ResNorComm.forEach(itmYear => {
                        lstYearComp.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataNorCom[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                //#endregion

                //#region ข้อร้องเรียนปกติ  Operation
                let lstdataOpera = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearOpera = [] as any;
                let ResOpera = res.lstdataNorOpera || [];
                if (ResOpera.length > 0) {
                    ResOpera.forEach(itmYear => {
                        lstYearOpera.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataOpera[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                //#endregion

                //#region ข้อร้องเรียนที่มีนัยสำคัญ  Commercial
                let lstdataSpecCom = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearSpecComm = [] as any;
                let ResSpecComm = res.lstdataSpecComm || [];
                if (ResSpecComm.length > 0) {
                    ResSpecComm.forEach(itmYear => {
                        lstYearSpecComm.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataSpecCom[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                //#endregion

                //#region ข้อร้องเรียนที่มีนัยสำคัญ  Operation
                let lstdataSpecOpe = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYearSpecOpera = [] as any;
                let ResSpecOperam = res.lstdataSpecOpera || [];
                if (ResSpecOperam.length > 0) {
                    ResSpecOperam.forEach(itmYear => {
                        lstYearSpecOpera.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstdataSpecOpe[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                //#endregion
                setdataDiv4([
                    {
                        sID: "1",
                        sTitle: "ข้อร้องเรียนปกติ : Commercial",
                        chartname: "chart-1-comp",
                        lstdata: lstdataNorCom,
                        lstYear: lstYearComp,
                    },
                    {
                        sID: "2",
                        sTitle: "ข้อร้องเรียนปกติ : Operation",
                        chartname: "chart-2-comp",
                        lstdata: lstdataOpera,
                        lstYear: lstYearOpera
                    },
                    {
                        sID: "3",
                        sTitle: "ข้อร้องเรียนที่มีนัยสำคัญ : Commercial",
                        chartname: "chart-3-comp",
                        lstdata: lstdataSpecCom,
                        lstYear: lstYearSpecComm
                    },
                    {
                        sID: "4",
                        sTitle: "ข้อร้องเรียนที่มีนัยสำคัญ : Operation",
                        chartname: "chart-4-comp",
                        lstdata: lstdataSpecOpe,
                        lstYear: lstYearSpecOpera
                    }
                ])


            })
        });
    }

    const GetDataTypeRequestDiv5 = (obj) => {
        BlockUI();
        AxiosPost(`Report/GetDataTypeRequestDiv5`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {

                let lstReq1 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let lstYear = [] as any;
                let ResultReq1 = res.lstdataReq1 || [];
                if (ResultReq1.length > 0) {
                    ResultReq1.forEach(itmYear => {
                        lstYear.push(itmYear.sYear)
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq1[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                let lstReq2 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let ResultReq2 = res.lstdataReq2 || [];
                if (ResultReq2.length > 0) {
                    ResultReq2.forEach(itmYear => {
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq2[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                let lstReq3 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let ResultReq3 = res.lstdataReq3 || [];
                if (ResultReq3.length > 0) {
                    ResultReq3.forEach(itmYear => {
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq3[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                let lstReq4 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let ResultReq4 = res.lstdataReq4 || [];
                if (ResultReq4.length > 0) {
                    ResultReq4.forEach(itmYear => {
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq4[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                let lstReq5 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let ResultReq5 = res.lstdataReq5 || [];
                if (ResultReq5.length > 0) {
                    ResultReq5.forEach(itmYear => {
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq5[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }
                let lstReq6 = [
                    { sMonth: "ม.ค.", nMonth: 1 },
                    { sMonth: "ก.พ.", nMonth: 2 },
                    { sMonth: "มี.ค.", nMonth: 3 },
                    { sMonth: "เม.ย.", nMonth: 4 },
                    { sMonth: "พ.ค.", nMonth: 5 },
                    { sMonth: "มิ.ย.", nMonth: 6 },
                    { sMonth: "ก.ค.", nMonth: 7 },
                    { sMonth: "ส.ค.", nMonth: 8 },
                    { sMonth: "ก.ย.", nMonth: 9 },
                    { sMonth: "ต.ค.", nMonth: 10 },
                    { sMonth: "พ.ย.", nMonth: 11 },
                    { sMonth: "ธ.ค.", nMonth: 12 },
                ] as any;

                let ResultReq6 = res.lstdataReq6 || [];
                if (ResultReq6.length > 0) {
                    ResultReq6.forEach(itmYear => {
                        let lstMonth = itmYear.lstMonth || [];
                        if (lstMonth.length > 0) {
                            lstMonth.forEach((itmMonth, ind) => {
                                Object.assign(lstReq6[ind], { [itmYear.sYear]: itmMonth.value });
                            });
                        }
                    });
                }

                setdataDiv5([
                    {
                        sID: "1",
                        sTitle: "ข้อร้องขอ : ขอความช่วยเหลือ",
                        chartname: "chart-1-req",
                        lstdata: lstReq1,
                        lstYear: lstYear,
                    },
                    {
                        sID: "2",
                        sTitle: "ข้อร้องขอ : ขอความร่วมมือ",
                        chartname: "chart-2-req",
                        lstdata: lstReq2,
                        lstYear: lstYear,
                    },
                    {
                        sID: "3",
                        sTitle: "ข้อร้องขอ : ขอข้อมูล",
                        chartname: "chart-3-req",
                        lstdata: lstReq3,
                        lstYear: lstYear,
                    },
                    {
                        sID: "4",
                        sTitle: "ข้อร้องขอ : ขอคำแนะนำ",
                        chartname: "chart-4-req",
                        lstdata: lstReq4,
                        lstYear: lstYear,
                    },
                    {
                        sID: "5",
                        sTitle: "ข้อร้องขอ : สอบถามข้อมูล",
                        chartname: "chart-5-req",
                        lstdata: lstReq5,
                        lstYear: lstYear,
                    },
                    {
                        sID: "6",
                        sTitle: "ข้อร้องขอ : อื่นๆ",
                        chartname: "chart-6-req",
                        lstdata: lstReq6,
                        lstYear: lstYear,
                    },
                ])



            })
        });
    }

    const GetDataSuggestionDiv6 = (obj) => {

        BlockUI();
        AxiosPost(`Report/GetDataSuggestionDiv6`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                onSetStateDiv6(res);
            })
        });
    }

    const onLoadGraphSuggestionDiv6 = (param) => {
        let obj = {
            "lstYear": form.getValues("arrYear") ?? null,
            "lstBA": form.getValues("arrBA") ?? null,
            ...param
        }
        BlockUI();
        AxiosPost(`Report/GetDataSuggestionDiv6`, obj, (res) => {
            UnBlockUI()
            ResultAPI(res, null, () => {
                onSetStateDiv6(res);
            })
        });
    }

    const onSetStateDiv6 = (res) => {
        let lstSuggestion = [
            { sMonth: "ม.ค.", nMonth: 1 },
            { sMonth: "ก.พ.", nMonth: 2 },
            { sMonth: "มี.ค.", nMonth: 3 },
            { sMonth: "เม.ย.", nMonth: 4 },
            { sMonth: "พ.ค.", nMonth: 5 },
            { sMonth: "มิ.ย.", nMonth: 6 },
            { sMonth: "ก.ค.", nMonth: 7 },
            { sMonth: "ส.ค.", nMonth: 8 },
            { sMonth: "ก.ย.", nMonth: 9 },
            { sMonth: "ต.ค.", nMonth: 10 },
            { sMonth: "พ.ย.", nMonth: 11 },
            { sMonth: "ธ.ค.", nMonth: 12 },
        ] as any;

        let lstYear = [] as any;
        let Result = res.lstdataSG || [];
        if (Result.length > 0) {
            Result.forEach(itmYear => {
                lstYear.push(itmYear.sYear)
                let lstMonth = itmYear.lstMonth || [];
                if (lstMonth.length > 0) {
                    lstMonth.forEach((itmMonth, ind) => {
                        Object.assign(lstSuggestion[ind], { [itmYear.sYear]: itmMonth.value });
                    });
                }
            });
        }

        setdataDiv6([
            {
                sID: "1",
                sTitle: "ข้อเสนอแนะ",
                chartname: "chart-1-sug",
                lstdata: lstSuggestion,
                lstYear: lstYear
            },
        ])

    }

    const GetDataBA = (obj) => {
        let objCMM = { ...obj, ...{ "nBA": 1 } }
        AxiosPost(`Report/GetDataBa`, objCMM, (res) => {
            ResultAPI(res, null, () => {
                setdataBaCMM(res)
            })
        });
        let objGSM = { ...obj, ...{ "nBA": 2 } }
        AxiosPost(`Report/GetDataBa`, objGSM, (res) => {
            ResultAPI(res, null, () => {
                setdataBaGSM(res)
            })
        });
        let objNGR = { ...obj, ...{ "nBA": 3 } }
        AxiosPost(`Report/GetDataBa`, objNGR, (res) => {
            ResultAPI(res, null, () => {
                setdataBaNGR(res)
            })
        });
        let objNGV = { ...obj, ...{ "nBA": 4 } }
        AxiosPost(`Report/GetDataBa`, objNGV, (res) => {
            ResultAPI(res, null, () => {
                setdataBaNGV(res)
            })
        });
    }

    const onLoadGraphGetDataBA =(param,nBA)=>{
        let obj = {
            "lstYear": form.getValues("arrYear") ?? null,
            "lstBA": form.getValues("arrBA") ?? null,
            ...param
        }
        AxiosPost(`Report/GetDataBa`, obj, (res) => {
            ResultAPI(res, null, () => {
                switch (nBA) {
                    case 1:
                        setdataBaCMM(res)
                        break;
                    case 2:
                        setdataBaGSM(res)
                        break;
                    case 3:
                        setdataBaNGR(res)
                        break;
                    case 4:
                        setdataBaNGV(res)
                        break;
                }
            })
        });
    }

    const onhandleInput = () => {
        setImgChart([]);
    }

    const onSearchData = async (isSet = true) => {
        BlockUI();
        setIsSearch(!IsSearch)
        setImgChart([])
        let formBA = form.getValues("arrBA") || []
        if (isSet == true) {
            if (formBA.length === 4) {
                setsBA("GBU")
            }
            else {
                let arrBA = optionBA.filter(f => formBA.includes(f.value)).map(item => item.label);
                setsBA(arrBA.join(', '))
            }
        }

        let obj = {
            "lstYear": form.getValues("arrYear") ?? null,
            "lstBA": form.getValues("arrBA") ?? null,
        }
        onGetOptionStaticVOC(obj)
        GetDataTotalDiv1(obj)
        GetDataDiv2(obj);
        GetDataTypeVOCDiv3(obj);
        GetDataTypeComplaintDiv4(obj);
        GetDataTypeRequestDiv5(obj);
        GetDataSuggestionDiv6(obj);
        GetDataBA(obj);
        UnBlockUI();
    };

  

    const ExportFileExcel = async () => {

        // await onGetBase64();
        await onExportExcel([]);

    }

    const onGetBase64 = async () => {
        let arrBA = (form.getValues("arrBA") || []);
        let arrBase64 = [] as any;

        let strHTMLSummaryVOC = document.getElementById("chart-summary-voc");
        if (strHTMLSummaryVOC) {
            let Element = strHTMLSummaryVOC as HTMLDivElement;
            let canvas = await html2canvas(Element);
            let image = canvas.toDataURL("image/png", 1.0);
            let obj = {
                id: 1,
                sDesc: "summaryVOC",
                sName: "จำนวนใบงานรวม",
                idDiv: 1,
                imgBase64: image
            }
            arrBase64.push(obj)
        }


        //#region BA 
        let strHTMLCMM = document.getElementById("CMM");
        if (strHTMLCMM) {
            let Element = strHTMLCMM as HTMLDivElement;
            let canvas = await html2canvas(Element);
            let image = canvas.toDataURL("image/png", 1.0);
            let obj = {
                id: 7,
                nOrder: 1,
                sDesc: "cmm",
                sName: "",
                idDiv: 7,
                imgBase64: image
            }
            arrBase64.push(obj)
        }
        let strHTMLGSM = document.getElementById("GSM");
        if (strHTMLGSM) {
            let Element = strHTMLGSM as HTMLDivElement;
            let canvas = await html2canvas(Element);
            let image = canvas.toDataURL("image/png", 1.0);
            let obj = {
                id: 8,
                nOrder: 1,
                sDesc: "GSM",
                sName: "",
                idDiv: 8,
                imgBase64: image
            }
            arrBase64.push(obj)
        }
        let strHTMLNGR = document.getElementById("NGR");
        if (strHTMLNGR) {
            let Element = strHTMLNGR as HTMLDivElement;
            let canvas = await html2canvas(Element);
            let image = canvas.toDataURL("image/png", 1.0);
            let obj = {
                id: 9,
                nOrder: 1,
                sDesc: "NGR",
                sName: "",
                idDiv: 9,
                imgBase64: image
            }
            arrBase64.push(obj)
        }
        let strHTMLNGV = document.getElementById("NGV");
        if (strHTMLNGV) {
            let Element = strHTMLNGV as HTMLDivElement;
            let canvas = await html2canvas(Element);
            let image = canvas.toDataURL("image/png", 1.0);
            let obj = {
                id: 10,
                nOrder: 1,
                sDesc: "NGV",
                sName: "",
                idDiv: 10,
                imgBase64: image
            }
            arrBase64.push(obj)
        }
        //#endregion

        await onExportExcel(arrBase64);
    }

    const onExportExcel = async (arrTimeline) => {
        if (nCountAllDiv === ImgChart.length) {
            let Param = {
                "lstYear": form.getValues("arrYear") ?? null,
                "lstBA": form.getValues("arrBA") ?? null,
                "ImgChart": [...ImgChart, ...arrTimeline],
                "Total": dataDiv1 != null ? dataDiv1.nTotal : 0,
                "Closed": dataDiv1 != null ? dataDiv1.nComplete : 0,
                "Inprogress": dataDiv1 != null ? dataDiv1.nInvestigate : 0,

            }
            let sFileName = `รายงานสถิติ Voice of Customer_${moment().format("DDMMYYYYHHmmss")}`;
            AxiosPostFileExcel(`ExportReport/ExportStaticsVOC`, Param, sFileName, null, null, BlockUI, UnBlockUI)
        }
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<QueryStatsRoundedIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="รายงาน"
                label_nameRoute="สถิติ Voice of Customer"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    {/* Search */}
                    <FormProvider {...form}>
                        <div className='div-border'>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                <Grid item xs={12} sm={6} md={4}>
                                    <MultiSelectForm
                                        name="arrYear"
                                        options={optionYear}
                                        label={'ปี'}
                                        limitTag={2}
                                        required={true}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={optionBA}
                                        label={'กลุ่มตลาด'}
                                        limitTag={1}
                                        required={false}
                                        onChange={(e) => {
                                            onhandleInput();
                                            if (e != null && e.length > 0) {
                                                let arrBA = (e || []).map(item => item.nBAID);
                                                setListBA(arrBA)
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} >
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnSearch onClick={form.handleSubmit(() => { onSearchData() })} />
                                        </Grid>

                                        <Grid item>
                                            {/* <BtnExportExcel onClick={() => { ExportFileExcel() }} /> */}
                                            <BtnExportExcel isDisabled={nCountAllDiv !== ImgChart.length} onClick={() => { ExportFileExcel() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </FormProvider>
                </Grid>
                <Grid item xs={12}>
                    {/* Total */}
                    <div className='div-border'>
                        <TotalVOCBarChart
                            sBA={sBA}
                            data={dataDiv1}
                            optionAll={optionAll}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            onLoadGraphTotolDiv1={onLoadGraphTotolDiv1}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {/* Pie and Bar */}
                    <div className='div-border'>
                        <PieAndBarSummaryChart
                            sBA={sBA}
                            data={dataDiv2}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {/* Type VOC */}
                    <div className='div-border'>
                        <TypeVOCBarChart
                            sBA={sBA}
                            data={dataDiv3}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {/* Type Complaint */}
                    <div className='div-border'>
                        <TypeComplaintBarChart
                            sBA={sBA}
                            data={dataDiv4}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {/* Type Request */}
                    <div className='div-border'>
                        <TypeRequestBarChart
                            sBA={sBA}
                            data={dataDiv5}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {/* Type Suggestion */}
                    <div className='div-border'>
                        <TypeSuggestionBarChart
                            sBA={sBA}
                            data={dataDiv6}
                            onLoadGraphSuggestionDiv6={onLoadGraphSuggestionDiv6}
                            optionAll={optionAll}
                            IsExport={IsExport}
                            IsSearch={IsSearch}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                {
                    ((form.getValues("arrBA") || []).filter(f => f == "1")).length > 0
                        ?
                        <Grid item xs={12}>
                            {/* Type CMM */}
                            <div className='div-border'>
                                <BASummaryChart
                                    name={"CMM"}
                                    data={dataBaCMM}
                                    optionAll={optionAll}
                                    onLoadGraphGetDataBA={onLoadGraphGetDataBA}
                                    nID={7}
                                    divPie={"pie-cmm"}
                                    divBar={"bar-cmm"}
                            IsSearch={IsSearch}
                            IsExport={IsExport}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        : null
                }
                {
                    ((form.getValues("arrBA") || []).filter(f => f == "2")).length > 0
                        ?
                        <Grid item xs={12}>
                            {/* Type GSM */}
                            <div className='div-border'>
                                <BASummaryChart
                                    name={"GSM"}
                                    data={dataBaGSM}
                                    optionAll={optionAll}
                                    onLoadGraphGetDataBA={onLoadGraphGetDataBA}
                                    nID={8}
                                    divPie={"pie-gsm"}
                                    divBar={"bar-gsm"}
                            IsSearch={IsSearch}
                            IsExport={IsExport}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        : null
                }
                {
                    ((form.getValues("arrBA") || []).filter(f => f == "3")).length > 0
                        ?
                        <Grid item xs={12}>
                            {/* Type NGR */}
                            <div className='div-border'>
                                <BASummaryChart
                                    name={"NGR"}
                                    data={dataBaNGR}
                                    optionAll={optionAll}
                                    onLoadGraphGetDataBA={onLoadGraphGetDataBA}
                                    nID={9}
                                    divPie={"pie-ngr"}
                                    divBar={"bar-ngr"}
                            IsSearch={IsSearch}
                            IsExport={IsExport}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        : null
                }
                {
                    ((form.getValues("arrBA") || []).filter(f => f == "4")).length > 0
                        ?
                        <Grid item xs={12}>
                            <div className='div-border'>
                                <BASummaryChart
                                    name={"NGV"}
                                    data={dataBaNGV}
                                    optionAll={optionAll}
                                    onLoadGraphGetDataBA={onLoadGraphGetDataBA}
                                    nID={10}
                                    divPie={"pie-ngv"}
                                    divBar={"bar-ngv"}
                            IsSearch={IsSearch}
                            IsExport={IsExport}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        : null
                }
            </Grid>
        </>
    )
}

export default StatisticsVOCReport